import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bbf7c44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-detail" }
const _hoisted_2 = { class: "news-detail-box" }
const _hoisted_3 = { class: "news-detail-box-img" }
const _hoisted_4 = { class: "news-detail-box-title" }
const _hoisted_5 = { class: "news-detail-box-time" }
const _hoisted_6 = { class: "news-detail-box-wz" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "news-detail-rt" }
const _hoisted_9 = { class: "news-detail-ad" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "news-detail-ad-line"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "news-detail-ad-bt" }, null, -1))
const _hoisted_13 = { class: "news-detail-ad-label" }
const _hoisted_14 = { class: "news-detail-ad" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "news-detail-ad-line"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "news-detail-ad-bt" }, null, -1))
const _hoisted_18 = { class: "news-detail-ad-label" }

import { defineComponent, onBeforeUpdate } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import { Plus, ZoomIn, Download, Delete } from "@element-plus/icons-vue";
import type { UploadFile } from "element-plus/es/components/upload/src/upload.type";
import { useRouter } from "vue-router";
import Bottom from "../components/bottom.vue";
import { onBeforeRouteUpdate } from "vue-router";
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
const bindData = reactive({
  information: {},
  company: {},
  informationList: [],
  activityTagId: "",
});
const information = (id:any) => {
  if (typeof id == "string") {
    store.dispatch("frontNewsModule/getInformation", { id: id }).then(
      (data) => {
        //成功
        bindData.information = data.result;
        bindData.activityTagId = data.result.activityTagId;
        pageInformationList(bindData.activityTagId, "push_time", "DESC");
      },
      (error) => {
        console.log(error.msg);
      }
    );
  }
};
var id = router.currentRoute.value.params.id;
information(id);

const pageInformationList = (
  activityTagId: string,
  orderField: string,
  orderingRule: string
) => {
  store
    .dispatch("frontNewsModule/pageInformationList", {
      curPage: 1,
      pageSize: 5,
      filtrate: {
        type: 1,
        activityTagId: activityTagId,
      },
      orderField: orderField,
      orderingRule: orderingRule,
    })
    .then(
      (data) => {
        //成功
        bindData.informationList = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const activeName = ref("first");

const tabHandleClick = (tab: any, event: Event) => {
  if (tab.index == 0) {
    pageInformationList(bindData.activityTagId, "push_time", "DESC");
  } else {
    pageInformationList(bindData.activityTagId, "sort", "DESC");
  }
};

const handleToDetail = (item: any) => {
  router.push("/frontDesk/newsList/newsDetail/" + item.id);
};

onBeforeRouteUpdate((to) => {
    var id = to.params.id;
    information(id);
});

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_star_filled = _resolveComponent("star-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_container, { class: "news-detail-main" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_carousel, { height: "300px" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).information.imageList, (image) => {
                    return (_openBlock(), _createBlock(_component_el_carousel_item, {
                      key: image.id,
                      style: {"display":"flex","justify-content":"center"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_image, {
                          class: "news-detail-box-banner",
                          src: image.thumbnailUrl
                        }, null, 8, ["src"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(bindData).information.name), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(bindData).information.pushTime), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                innerHTML: _unref(bindData).information.content
              }, null, 8, _hoisted_7)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_tabs, {
              modelValue: activeName.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
              class: "demo-tabs",
              onTabClick: tabHandleClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "最新发布",
                  name: "first"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).informationList, (information) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "news-detail-ad-box",
                          key: information.id,
                          onClick: () => handleToDetail(information)
                        }, [
                          (information.id!=_unref(bindData).information.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_el_carousel, {
                                  class: "news-detail-ad",
                                  height: "200px"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(information.imageList, (image) => {
                                      return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                        key: image.id,
                                        style: {"display":"flex","justify-content":"center"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_image, {
                                            class: "news-detail-ad-banner",
                                            mode: "widthfix",
                                            src: image.thumbnailUrl
                                          }, null, 8, ["src"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024),
                                _hoisted_12,
                                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(moment)(information.pushTime).format("YYYY-MM-DD")) + "  " + _toDisplayString(information.name), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_10))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "热门阅读",
                  name: "second"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).informationList, (information) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "news-detail-ad-box",
                          style: {"cursor":"pointer"},
                          key: information.id,
                          onClick: () => handleToDetail(information)
                        }, [
                          (information.id!=_unref(bindData).information.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createVNode(_component_el_carousel, {
                                  class: "news-detail-ad",
                                  height: "200px"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(information.imageList, (image) => {
                                      return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                        key: image.id,
                                        style: {"display":"flex","justify-content":"center"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_image, {
                                            class: "news-detail-ad-banner",
                                            mode: "widthfix",
                                            src: image.thumbnailUrl
                                          }, null, 8, ["src"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024),
                                _hoisted_17,
                                _createElementVNode("div", _hoisted_18, [
                                  _createVNode(_component_el_icon, {
                                    size: _ctx.size,
                                    color: _ctx.color
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_star_filled)
                                    ]),
                                    _: 1
                                  }, 8, ["size", "color"]),
                                  _createTextVNode(_toDisplayString(information.sort) + "  " + _toDisplayString(information.name), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_15))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(Bottom)
  ]))
}
}

})